import { Menu } from "@mui/material";

import Helpers from "../../../commons/helpers";
import CustomIcon from "../../CustomIcon";
import CustomMenuItem from "../CustomMenuItem";

import { DataTableProps } from "..";
import { IActionMenuItem } from "../../../commons/interfaces";

export const PopupMenu = <T,>({
    actionList,
    currentItem,
    openMenu,
    setOpenMenu,
}: Pick<DataTableProps<T>, "actionList"> & {
    currentItem: any;
    setOpenMenu: React.Dispatch<React.SetStateAction<HTMLElement>>;
    openMenu: HTMLElement;
}): JSX.Element => {
    const handleCloseMenu = () => setOpenMenu(null);

    const _actionListTemp: any[] = (Helpers.isFunction(actionList) ? actionList(currentItem) : actionList)?.filter((item) => item !== false) || [];
    const _actionListTempSlice = _actionListTemp?.length > 3 ? _actionListTemp?.slice(2) : [];

    if (!_actionListTempSlice || _actionListTempSlice.length === 0) return null;

    return (
        <Menu
            anchorEl={openMenu}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            anchorReference={undefined}
            open={Boolean(openMenu)}
            onClose={handleCloseMenu}
        >
            {_actionListTempSlice.map((item: IActionMenuItem) => {
                if (
                    !Helpers.isNullOrEmpty(item?.hideWhen?.key) &&
                    !Helpers.isNullOrEmpty(currentItem?.original?.[item.hideWhen.key]) &&
                    item.hideWhen?.values?.some((value) => currentItem?.original?.[item.hideWhen.key] === value)
                )
                    return null;

                return (
                    <CustomMenuItem
                        key={item.key}
                        title={item.title}
                        icon={<CustomIcon icon={item.icon} iconName={item.iconName} />}
                        onClick={() => {
                            setOpenMenu(null);
                            if (Helpers.isFunction(item.callback)) {
                                item.callback(currentItem);
                            }
                        }}
                    />
                );
            })}
        </Menu>
    );
};

export default PopupMenu;
